import CompactSWIcon from "../../assets/product-list-assets/compact2.svg";
import type { ProductListGroup } from "../../types";

export const productListSwitchingCompact: ProductListGroup = {
  id: "productListSwitchingCompact",
  title: "productListGroup.switchingCompact.title",
  icon: {
    src: CompactSWIcon,
    width: 24,
    height: 24,
  },
};
